import { EnvelopeIcon } from '@phosphor-icons/react/dist/ssr/Envelope';
import { CubeIcon } from '@phosphor-icons/react/dist/ssr/Cube';
import { ArrowLeftIcon } from '@phosphor-icons/react/dist/ssr/ArrowLeft';
import { SealCheckIcon } from '@phosphor-icons/react/dist/ssr/SealCheck';
import { UserIcon as PhUser } from '@phosphor-icons/react/dist/ssr/User';
import { NotePencilIcon } from '@phosphor-icons/react/dist/ssr/NotePencil';
import { XIcon } from '@phosphor-icons/react/dist/ssr/X';
import { DotsSixVerticalIcon } from '@phosphor-icons/react/dist/ssr/DotsSixVertical';

import { CheckSquareIcon } from '@phosphor-icons/react/dist/ssr/CheckSquare';
import { ImageIcon as PhImage } from '@phosphor-icons/react/dist/ssr/Image';
import { LinkSimpleIcon } from '@phosphor-icons/react/dist/ssr/LinkSimple';
import { TrashIcon as PhTrash } from '@phosphor-icons/react/dist/ssr/Trash';
import { PlusIcon as PhPlus } from '@phosphor-icons/react/dist/ssr/Plus';
import { SwordIcon } from '@phosphor-icons/react/dist/ssr/Sword';
import { GlobeHemisphereWestIcon } from '@phosphor-icons/react/dist/ssr/GlobeHemisphereWest';
import { NotebookIcon } from '@phosphor-icons/react/dist/ssr/Notebook';
import { TimerIcon as PhTimer } from '@phosphor-icons/react/dist/ssr/Timer';
import { CheckIcon as PhCheck } from '@phosphor-icons/react/dist/ssr/Check';
import { CircleIcon as PhCircle } from '@phosphor-icons/react/dist/ssr/Circle';
import { PaperclipIcon as PhPaperclip } from '@phosphor-icons/react/dist/ssr/Paperclip';
import { FileTextIcon as PhFileText } from '@phosphor-icons/react/dist/ssr/FileText';
import { CaretDownIcon } from '@phosphor-icons/react/dist/ssr/CaretDown';
import { ClockCounterClockwiseIcon } from '@phosphor-icons/react/dist/ssr/ClockCounterClockwise';
import { ArrowSquareOutIcon } from '@phosphor-icons/react/dist/ssr/ArrowSquareOut';
import { CaretUpIcon } from '@phosphor-icons/react/dist/ssr/CaretUp';
import { FlameIcon } from '@phosphor-icons/react/dist/ssr/Flame';
import { PowerIcon as PhPower } from '@phosphor-icons/react/dist/ssr/Power';
import { PauseIcon as PhPause } from '@phosphor-icons/react/dist/ssr/Pause';
import { PlayIcon as PhPlay } from '@phosphor-icons/react/dist/ssr/Play';
import { SignOutIcon as PhSignOut } from '@phosphor-icons/react/dist/ssr/SignOut';
import { LockIcon as PhLock } from '@phosphor-icons/react/dist/ssr/Lock';
import { WarningIcon as PhWarning } from '@phosphor-icons/react/dist/ssr/Warning';
import { DownloadSimpleIcon as PhDownloadSimple } from '@phosphor-icons/react/dist/ssr/DownloadSimple';
import { BellIcon as PhBell } from '@phosphor-icons/react/dist/ssr/Bell';
import { SpinnerIcon as PhSpinner } from '@phosphor-icons/react/dist/ssr/Spinner';
import { TargetIcon as PhTarget } from '@phosphor-icons/react/dist/ssr/Target';
import { ClipboardIcon as PhClipboard } from '@phosphor-icons/react/dist/ssr/Clipboard';
import { CouchIcon as PhCouch } from '@phosphor-icons/react/dist/ssr/Couch';

import { iconTokens } from '../../tokens/categories/icon.tokens';
import * as iconCss from './icons.css';

// DESIGN.md Atom Standards §6: Icon은 default aria-hidden="true". 의미 전달 시 SuccessCheckIcon/WarningIcon처럼 role="img" + aria-label 명시.

export const EmailIcon = () => (
  <EnvelopeIcon size={iconTokens.size.lg} weight="light" aria-hidden="true" />
);

export const BackArrowIcon = ({ className }: { className?: string }) => (
  <ArrowLeftIcon size={iconTokens.size.sm} weight="bold" className={className} aria-hidden="true" />
);

export const SuccessCheckIcon = ({ className }: { className?: string }) => (
  <SealCheckIcon weight="duotone" className={className} role="img" aria-label="인증 성공" />
);

export const UserIcon = ({ size = iconTokens.size.lg }: { size?: number }) => (
  <PhUser size={size} weight="light" aria-hidden="true" />
);

export const MemoIcon = ({
  size = iconTokens.size.xl,
  className,
}: {
  size?: number;
  className?: string;
}) => <NotePencilIcon size={size} weight="duotone" className={className} aria-hidden="true" />;

export const CloseIcon = ({
  size = iconTokens.size.md,
  className,
}: {
  size?: number;
  className?: string;
}) => <XIcon size={size} weight="bold" className={className} aria-hidden="true" />;

export const DragHandleIcon = ({
  size = iconTokens.size.md,
  className,
}: {
  size?: number;
  className?: string;
}) => <DotsSixVerticalIcon size={size} weight="bold" className={className} aria-hidden="true" />;

export const CheckpointIcon = ({
  size = iconTokens.size.lg,
  className,
}: {
  size?: number;
  className?: string;
}) => <CheckSquareIcon size={size} weight="duotone" className={className} aria-hidden="true" />;

export const ImageBlockIcon = ({
  size = iconTokens.size.lg,
  className,
}: {
  size?: number;
  className?: string;
}) => <PhImage size={size} weight="duotone" className={className} aria-hidden="true" />;

export const LinkBlockIcon = ({
  size = iconTokens.size.lg,
  className,
}: {
  size?: number;
  className?: string;
}) => <LinkSimpleIcon size={size} weight="duotone" className={className} aria-hidden="true" />;

export const TrashIcon = ({
  size = iconTokens.size.md,
  className,
}: {
  size?: number;
  className?: string;
}) => <PhTrash size={size} weight="regular" className={className} aria-hidden="true" />;

export const PlusIcon = ({
  size = iconTokens.size.md,
  className,
}: {
  size?: number;
  className?: string;
}) => <PhPlus size={size} weight="bold" className={className} aria-hidden="true" />;

export const QuestIcon = ({
  size = iconTokens.size.lg,
  className,
}: {
  size?: number;
  className?: string;
}) => <SwordIcon size={size} weight="duotone" className={className} aria-hidden="true" />;

export const WorldQuestIcon = ({
  size = iconTokens.size.lg,
  className,
}: {
  size?: number;
  className?: string;
}) => (
  <GlobeHemisphereWestIcon size={size} weight="duotone" className={className} aria-hidden="true" />
);

export const LoungeIcon = ({
  size = iconTokens.size.lg,
  className,
}: {
  size?: number;
  className?: string;
}) => <PhCouch size={size} weight="duotone" className={className} aria-hidden="true" />;

/** 사내 제품 — 개발 퀘스트 입구(헤더 캡슐). 퀘스트 가족의 칼 아이콘과 일부러 다르다. */
export const ProductIcon = ({
  size = iconTokens.size.lg,
  className,
}: {
  size?: number;
  className?: string;
}) => <CubeIcon size={size} weight="duotone" className={className} aria-hidden="true" />;

export const WorkLogIcon = ({
  size = iconTokens.size.lg,
  className,
}: {
  size?: number;
  className?: string;
}) => <NotebookIcon size={size} weight="duotone" className={className} aria-hidden="true" />;

export const TimerIcon = ({
  size = iconTokens.size.md,
  className,
}: {
  size?: number;
  className?: string;
}) => <PhTimer size={size} weight="regular" className={className} aria-hidden="true" />;

export const CheckIcon = ({
  size = iconTokens.size.sm,
  className,
}: {
  size?: number;
  className?: string;
}) => <PhCheck size={size} weight="bold" className={className} aria-hidden="true" />;

export const CircleIcon = ({
  size = iconTokens.size.sm,
  className,
}: {
  size?: number;
  className?: string;
}) => <PhCircle size={size} weight="regular" className={className} aria-hidden="true" />;

export const PaperclipIcon = ({
  size = iconTokens.size.xl,
  className,
}: {
  size?: number;
  className?: string;
}) => <PhPaperclip size={size} weight="duotone" className={className} aria-hidden="true" />;

export const FileTextIcon = ({
  size = iconTokens.size.xl,
  className,
}: {
  size?: number;
  className?: string;
}) => <PhFileText size={size} weight="duotone" className={className} aria-hidden="true" />;

/** 변경 이력 — 되감기는 시계가 "지나간 것을 되짚는다" 를 그림 하나로 말한다. */
export const HistoryIcon = ({
  size = iconTokens.size.sm,
  className,
}: {
  size?: number;
  className?: string;
}) => (
  <ClockCounterClockwiseIcon
    size={size}
    weight="regular"
    className={className}
    aria-hidden="true"
  />
);

export const ExpandDownIcon = ({
  size = iconTokens.size.sm,
  className,
}: {
  size?: number;
  className?: string;
}) => <CaretDownIcon size={size} weight="bold" className={className} aria-hidden="true" />;

export const ExpandUpIcon = ({
  size = iconTokens.size.sm,
  className,
}: {
  size?: number;
  className?: string;
}) => <CaretUpIcon size={size} weight="bold" className={className} aria-hidden="true" />;

export const StreakIcon = ({
  size = iconTokens.size.md,
  className,
}: {
  size?: number;
  className?: string;
}) => <FlameIcon size={size} weight="fill" className={className} aria-hidden="true" />;

export const PowerIcon = ({
  size = iconTokens.size.xl,
  className,
}: {
  size?: number;
  className?: string;
}) => <PhPower size={size} weight="bold" className={className} aria-hidden="true" />;

export const PauseIcon = ({
  size = iconTokens.size.md,
  className,
}: {
  size?: number;
  className?: string;
}) => <PhPause size={size} weight="fill" className={className} aria-hidden="true" />;

export const PlayIcon = ({
  size = iconTokens.size.md,
  className,
}: {
  size?: number;
  className?: string;
}) => <PhPlay size={size} weight="fill" className={className} aria-hidden="true" />;

export const SignOutIcon = ({
  size = iconTokens.size.md,
  className,
}: {
  size?: number;
  className?: string;
}) => <PhSignOut size={size} weight="bold" className={className} aria-hidden="true" />;

export const LockIcon = ({
  size = iconTokens.size.lg,
  className,
}: {
  size?: number;
  className?: string;
}) => <PhLock size={size} weight="light" className={className} aria-hidden="true" />;

export const WarningIcon = ({ className }: { className?: string }) => (
  <PhWarning
    size={iconTokens.size.md}
    weight="fill"
    className={className}
    role="img"
    aria-label="경고"
  />
);

export const DownloadIcon = ({
  size = iconTokens.size.md,
  className,
}: {
  size?: number;
  className?: string;
}) => <PhDownloadSimple size={size} weight="bold" className={className} aria-hidden="true" />;

export const BellIcon = ({
  size = iconTokens.size.xl,
  className,
}: {
  size?: number;
  className?: string;
}) => <PhBell size={size} weight="duotone" className={className} aria-hidden="true" />;

// I1 (today-page-storybook-polish-plan §6.1) — TodayPage 상태 아이콘 4종.
// Spinner/Target/Clipboard 신규, Warning 은 이미 위에 정의됨.

export const SpinnerIcon = ({
  size = iconTokens.size.lg,
  className,
}: {
  size?: number;
  className?: string;
}) => (
  <PhSpinner
    size={size}
    weight="bold"
    className={className ? `${iconCss.spinnerAnim} ${className}` : iconCss.spinnerAnim}
    role="img"
    aria-label="로딩 중"
  />
);

export const TargetIcon = ({
  size = iconTokens.size.xl,
  className,
}: {
  size?: number;
  className?: string;
}) => <PhTarget size={size} weight="duotone" className={className} aria-hidden="true" />;

export const ClipboardIcon = ({
  size = iconTokens.size.xl,
  className,
}: {
  size?: number;
  className?: string;
}) => <PhClipboard size={size} weight="duotone" className={className} aria-hidden="true" />;

export const OpenExternalIcon = ({
  size = iconTokens.size.sm,
  className,
}: {
  size?: number;
  className?: string;
}) => <ArrowSquareOutIcon size={size} weight="regular" className={className} aria-hidden="true" />;
